import { render, staticRenderFns } from "./TerminalsForm.vue?vue&type=template&id=456d9654"
import script from "./TerminalsForm.vue?vue&type=script&lang=js"
export * from "./TerminalsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports